module.exports = __webpack_public_path__ + "img/6_New Chatroom created.9041c74e.svg";